// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__35dWd","subheader":"ReorderModal_subheader__3ovQ3","listWrap":"ReorderModal_listWrap__1-grJ"};